import type { EditorCommands } from "@linempo/editor-session";
import type { EditCommand, EditTransaction } from "@linempo/project-domain";

/** Reveal a successfully placed scene using selectClip's story-target/playhead behavior. */
export async function commitAndRevealPlacement(commands: Pick<EditorCommands, "commit" | "selectClip">, input: EditCommand | EditTransaction, placement?: EditCommand) {
  const edit = placement ?? ("_tag" in input ? input : undefined);
  const result = await commands.commit(input);
  if (edit && (edit._tag === "InsertAssetAt" || edit._tag === "MapAssetToCues" || edit._tag === "ReplaceSceneAsset")) await commands.selectClip(edit.sceneId);
  return result;
}
